module.exports = __webpack_public_path__ + "img/floor_OG4.b0b62482.svg";